import BaseReducer from "./BaseReducer";

class LoginReducer extends BaseReducer {
  domain = "Auth";
  type = "Session";

  initialState = {
    menu: [],
    sites: [],
    siteGuid: null,
    name: null,
    version: null,
    sessionkey: null,
    resetPassword: false,
    currencyFormat: null,
    currencySymbol: null,
    minEntryRegex: null,
    isDesktop: false,
    isInReadMode: true,
    optionShowSitesList: false,
    optionDisplaySessionsInCompliance: true,
    optionAllowReviewInteraction: true,
    optionShowComplianceAlerts: true,
    optionComplianceShowReviews: true,
    optionAllowCustomerStateChange: true,
    site: {
      id: "",
      retailerName: "",
      siteCode: "",
      regionCode: "",
      location: "",
      subCompanyName: "",
      town: "",
      guid: "",
    },
    seCompanyAccessToken: "",
  };
}

const reducer = new LoginReducer();

export default reducer;
